






























































































































































































































































import { Vue, Component } from 'vue-property-decorator';
import clounbtn from '../components/Cloundbtn.vue';
import { isWeiXin } from '@/common/ts/common';
import { Toast, Swipe, SwipeItem } from 'vant';
import { saveinfo, getBaseInfo, checkUser } from '../api';
import qs from 'qs';
Vue.use(Swipe);
Vue.use(SwipeItem);

@Component({
  components: {
    clounbtn,
  },
})
export default class Rule extends Vue {
  isInto: boolean = true;
  showload: boolean = false;
  leftimg: any = require('../assets/pageinx/page3/baomingbtn.png');
  midimg: any = require('../assets/pageinx/page3/btnmid.png');
  rightimg: any = require('../assets/pageinx/page3/btnright.png');
  unionid: string | null = '';
  actNextimg: boolean = false;
  actNextimgTimer: any = null;
  timelist: any = {
    baomingtimestr: 1688598000000, //2023-07-06 07:00:00
    baomingtimeend: 1689177600000, //2023-07-13 00:00:00
  };
  async mounted() {
    setTimeout(() => {
      this.isInto = false;
    }, 200);
    setTimeout(() => {
      if (this.$route.query.showRule) {
        this.torule();
      }
    }, 1000);

    this.actNextimgTimer = setInterval(() => {
      this.actNextimg = !this.actNextimg;
    }, 1000);
    this.unionid = window.localStorage.getItem('unionid') + '';
    window.addEventListener('scroll', this.handleScroll);
  }
  destroyed() {
    clearInterval(this.actNextimgTimer);
    window.removeEventListener('scroll', this.handleScroll);
  }
  torule() {
    this.$router.push('rule');
  }
  intoinfo() {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      console.log(this.unionid);
      this.WechatLogin();
      return false;
    }
    const nowtime = new Date().getTime();
    if (parseInt(this.timelist.baomingtimeend) < nowtime) {
      Toast('报名已结束');
      return false;
    }
    if (parseInt(this.timelist.baomingtimestr) > nowtime) {
      Toast('报名尚未开始');
      return false;
    }
    checkUser(this.unionid + '').then((res: any) => {
      if (res.code === 200) {
        this.$router.push('succesinfo');
      } else {
        setTimeout(() => {
          this.$router.push('ininfo');
        }, 500);
      }
    });
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx536e2bb3e4f6664f';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  intowork() {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    checkUser(this.unionid + '').then((res: any) => {
      if (res.code !== 200) {
        Toast('请报名后再上传作品');
        return false;
      } else {
        this.$router.push('toupload');
      }
    });
  }
  intovote() {
    if (!isWeiXin()) {
      Toast('请在微信中打开，参与活动');
      return false;
    } else if (
      (this.unionid === null || this.unionid === 'null') &&
      isWeiXin()
    ) {
      this.WechatLogin();
      return false;
    }
    console.log(this.unionid);
    const nowtime = parseInt(new Date().getTime() + '');
    if (nowtime < parseInt(this.timelist.baomingtimestr)) {
      Toast('作品投票尚未开始');
      return false;
    }
    this.$router.push('intovote');
  }
  handleScroll() {
    if (this.showload) {
      return false;
    }
    //
    //半秒时间恢复顶部或者下一页
    setTimeout(() => {
      this.showload = false;
      window.scrollTo(4, 4);
    }, 500);
  }

  loadNextPage() {
    setTimeout(() => {
      this.showload = false;
    }, 1000);
  }
}
